import React from "react";
import { SiteHeader } from "@/components/site-header";

interface PageWrapperProps {
    title: string;
    children: React.ReactNode;
    primaryAction?: React.ReactNode;
    description?: string;
}

export const PageWrapper = ({
    title,
    children,
    primaryAction,
    description,
}: PageWrapperProps) => {
    return (
        <div className="flex w-full flex-1 flex-col">
            <SiteHeader
                title={title}
                primaryAction={primaryAction}
                description={description}
            />
            <div className="pt-16">{children}</div>
        </div>
    );
};
